import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";

const useBrandLogo = () => {
  const { me } = useAuth() || {};
  return me?.branding?.logo ? { src: me.branding.logo, alt: me.branding.name || "Logo" } : null;
};

export const Logo = ({ inverted = false, className }) => {
  const b = useBrandLogo();
  return (
    <div className={cn("flex items-center", className)} data-testid="app-logo">
      <img src={b ? b.src : inverted ? "/brand/on-suite-white.png" : "/brand/on-suite.png"} alt={b ? b.alt : "ON! Suite"} className="h-7 w-auto max-w-[160px] object-contain" />
    </div>
  );
};

export const FullLogo = ({ className }) => {
  const b = useBrandLogo();
  return <img src={b ? b.src : "/brand/on-suite.png"} alt={b ? b.alt : "ON! Suite"} className={cn("h-10 w-auto max-w-[220px] object-contain", className)} data-testid="app-full-logo" />;
};
